import { Box } from '@dealstack/frontend/shared/components/Box/Box';
import React, { memo } from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	children?: React.ReactNode;
}

const SystemInfoLayout = ({ className, children }: Props) => {
	return (
		<div className={className}>
			<ContentBox>{children}</ContentBox>
		</div>
	);
};

export const ContentBox = styled(Box)`
	padding: 2rem;
`;

const Memoized = memo(SystemInfoLayout);
const Styled = styled(Memoized)`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme }) => theme.v2.color.secondary[200]};

	width: 100vw;
	height: 100vh;
`;

export { Styled as SystemInfoLayout };
